// --------------------------------------------------------------------------------
// NOTE: This file was automatically generated, do not modify manually.
// --------------------------------------------------------------------------------
import { Airspace } from './Airspace';
import { Volume } from './Volume';
import { VolumePrism } from './VolumePrism';
import { PrismRange } from './PrismRange';
import { Polygon2D } from './Polygon2D';
import { Coordinate } from './Coordinate';

export class Convection implements IConvection {
    id!: string;
    level!: number;
    isInvalid!: boolean;
    likeliness!: string | undefined;
    convectionFraction!: string | undefined;
    trafficVolumes!: Airspace[];
    weatherVolumes!: Volume[];

    constructor(data?: IConvection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.level = _data["level"];
            this.isInvalid = _data["isInvalid"];
            this.likeliness = _data["likeliness"];
            this.convectionFraction = _data["convectionFraction"];
            if (Array.isArray(_data["trafficVolumes"])) {
                this.trafficVolumes = [] as any;
                for (let item of _data["trafficVolumes"])
                    this.trafficVolumes!.push(Airspace.fromJS(item));
            }
            if (Array.isArray(_data["weatherVolumes"])) {
                this.weatherVolumes = [] as any;
                for (let item of _data["weatherVolumes"])
                    this.weatherVolumes!.push(Volume.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Convection {
        data = typeof data === 'object' ? data : {};
        let result = new Convection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["level"] = this.level;
        data["isInvalid"] = this.isInvalid;
        data["likeliness"] = this.likeliness;
        data["convectionFraction"] = this.convectionFraction;
        if (Array.isArray(this.trafficVolumes)) {
            data["trafficVolumes"] = [];
            for (let item of this.trafficVolumes)
                data["trafficVolumes"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.weatherVolumes)) {
            data["weatherVolumes"] = [];
            for (let item of this.weatherVolumes)
                data["weatherVolumes"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IConvection {
    id: string;
    level: number;
    isInvalid: boolean;
    likeliness: string | undefined;
    convectionFraction: string | undefined;
    trafficVolumes: Airspace[];
    weatherVolumes: Volume[];
}